import { VignetteEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const Vignette = wrapEffect(VignetteEffect)
